import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaLightbulb, FaRandom, FaHeart, FaStar, FaMusic, FaPlane, FaCoffee, FaCamera } from 'react-icons/fa';

const icebreakers = [
  {
    category: 'romantique',
    icon: FaHeart,
    color: '#FF69B4',
    questions: [
      "Quel est ton endroit préféré pour un premier rendez-vous ?",
      "Quelle est la chose la plus romantique qu'on t'ait faite ?",
      "Si tu pouvais partir demain, où irais-tu ?",
      "Quel est ton rêve le plus fou en amour ?",
      "La montagne ou la mer pour un week-end en amoureux ?"
    ]
  },
  {
    category: 'fun',
    icon: FaStar,
    color: '#FFD700',
    questions: [
      "Quel est ton talent caché ?",
      "Si tu étais un super-héros, qui serais-tu ?",
      "Quelle est la chose la plus folle que tu aies faite ?",
      "Ton film préféré pour un dimanche pluvieux ?",
      "Plutôt pizza ou sushi ?"
    ]
  },
  {
    category: 'passions',
    icon: FaMusic,
    color: '#4A90E2',
    questions: [
      "Quel genre de musique écoutes-tu ?",
      "As-tu une passion qui te tient à cœur ?",
      "Que fais-tu pendant ton temps libre ?",
      "Pratiques-tu un sport ?",
      "Quel est ton hobby préféré ?"
    ]
  },
  {
    category: 'voyage',
    icon: FaPlane,
    color: '#50C878',
    questions: [
      "Quel est le plus beau voyage que tu aies fait ?",
      "Où aimerais-tu aller prochainement ?",
      "Ville ou campagne pour les vacances ?",
      "As-tu déjà voyagé seul(e) ?",
      "Quelle culture t'intrigue le plus ?"
    ]
  },
  {
    category: 'lifestyle',
    icon: FaCoffee,
    color: '#8B4513',
    questions: [
      "Plutôt café du matin ou thé de l'après-midi ?",
      "Quel est ton rituel matinal ?",
      "Plutôt lève-tôt ou couche-tard ?",
      "Comment passes-tu tes week-ends ?",
      "Plutôt cuisine maison ou restaurant ?"
    ]
  },
  {
    category: 'photos',
    icon: FaCamera,
    color: '#9370DB',
    questions: [
      "Tu as de superbes photos, tu aimes photographier ?",
      "Quel est ton souvenir préféré capturé en photo ?",
      "Plutôt selfies ou paysages ?",
      "As-tu un appareil photo ou juste ton téléphone ?",
      "Quel endroit aimerais-tu photographier ?"
    ]
  }
];

const IcebreakerSuggestions = ({ onSelect, isVisible }) => {
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [currentSuggestion, setCurrentSuggestion] = useState('');

  const getRandomSuggestion = (category) => {
    const categoryData = icebreakers.find(i => i.category === category);
    if (categoryData) {
      const randomIndex = Math.floor(Math.random() * categoryData.questions.length);
      setCurrentSuggestion(categoryData.questions[randomIndex]);
    }
  };

  const handleCategoryClick = (category) => {
    setSelectedCategory(category);
    getRandomSuggestion(category);
  };

  const handleShuffle = () => {
    if (selectedCategory) {
      getRandomSuggestion(selectedCategory);
    }
  };

  const handleUse = () => {
    if (currentSuggestion) {
      onSelect(currentSuggestion);
      setSelectedCategory(null);
      setCurrentSuggestion('');
    }
  };

  if (!isVisible) return null;

  return (
    <motion.div
      className="icebreaker-suggestions"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 20 }}
    >
      <div className="icebreaker-header">
        <FaLightbulb className="icebreaker-icon" />
        <span>Cassez la glace 💫</span>
      </div>

      {!selectedCategory ? (
        <div className="icebreaker-categories">
          {icebreakers.map((item) => (
            <motion.button
              key={item.category}
              className="icebreaker-category-btn"
              style={{ '--category-color': item.color }}
              onClick={() => handleCategoryClick(item.category)}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <item.icon className="category-icon" />
              <span>{item.category}</span>
            </motion.button>
          ))}
        </div>
      ) : (
        <motion.div
          className="icebreaker-suggestion"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
        >
          <div className="suggestion-content">
            <p>{currentSuggestion}</p>
          </div>
          <div className="suggestion-actions">
            <button className="btn-shuffle" onClick={handleShuffle}>
              <FaRandom /> Autre
            </button>
            <button className="btn-use" onClick={handleUse}>
              Utiliser ✨
            </button>
          </div>
          <button 
            className="btn-back"
            onClick={() => setSelectedCategory(null)}
          >
            ← Retour aux catégories
          </button>
        </motion.div>
      )}
    </motion.div>
  );
};

export default IcebreakerSuggestions;
